<template>
  <div class="content--sinoreg page--cadastroObito">
    <HeaderForSection class="mb-4"
                      :icone="1"
                      :data-inicio="dataInicio" />

    <StepsForWizard class="mb-5"
                    :ativo="passoAtivo"
                    :passos="passos"
                    tamanho="sm" />
    <PassoFalecido v-if="(passoAtivo === 0)"
                   class="py-2"
                   :data="dados"
                   :read-only="true"
                   :prop-cartorio="dadosCartorio"
                   @changed="changed" />

    <PassoDadosFalecimento v-if="(passoAtivo === 1)"
                           class="py-2"
                           :data="dados"
                           :read-only="true"
                           :prop-validator="true"
                           :prop-cartorio="dadosCartorio"
                           @changed="changed" />

    <PassoOutrasInfo v-if="(passoAtivo === 2)"
                     class="py-2"
                     :data="dados"
                     :read-only="true"
                     :prop-cartorio="dadosCartorio"
                     @changed="changed"
                     @documentoRemoved="documentoRemoved"
                     @verifyParte="verifyParte" />

    <PassoRegistro v-if="(passoAtivo === 3)"
                   class="py-2"
                   :data="dados"
                   :read-only="true"
                   @registroUpdated="updatePassoRegistro" />

    <div class="cadastroObito_footer mb-2 border-top border-primary pt-3">
      <div class="row no-gutters justify-content-end align-items-center">
        <div class="d-inline-block">
          <b-link v-if="passoAtivo === 0"
                  class="btn btn-sm btn-dark"
                  :to="{ name: 'rei_dashboard' }">
            Voltar
          </b-link>
          <button v-if="!(passoAtivo === 0)"
                  class="btn btn-sm btn-dark"
                  type="button"
                  @click="previousStep">
            Voltar
          </button>
        </div>

        <div class="d-inline-block ml-2">
          <button class="btn btn-sm btn-primary"
                  type="button"
                  @click="nextStep">
            {{ (passoAtivo === 3) ? 'Cadastrar Registro' : 'Continuar' }}
          </button>
        </div>
      </div>
    </div>
    <b-modal v-if="rascunhoFound"
             id="modalRascunho"
             ref="modalRascunho"
             no-close-on-backdrop
             no-close-on-esc
             :visible="true"
             centered
             size="xl">
      <div slot="modal-header"
           class="modalGenitor_title w-100">
        Rascunho encontrado
      </div>
      <SearchRascunho :prop-rascunho="rascunhoFound" />
      <div slot="modal-footer"
           slot-scope="{ ok, cancel }">
        <button class="btn btn-sm btn-primary"
                @click="() => { cancel(); newRascunho(); }">
          Continuar com o Cadastro
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
  /* components */
  import HeaderForSection from '@/components/SofiaRei/HeaderForSection.vue'
  import StepsForWizard from '@/components/SofiaRei/StepsForWizard.vue'
  import PassoFalecido from '@/components/SofiaRei/Obito/Passos/PassoFalecido.vue'
  import PassoDadosFalecimento from '@/components/SofiaRei/Obito/Passos/PassoDadosFalecimento.vue'
  import PassoOutrasInfo from '@/components/SofiaRei/Obito/Passos/PassoOutrasInfo.vue'
  import PassoRegistro from '@/components/SofiaRei/Obito/Passos/PassoRegistro.vue'
  import SearchRascunho from "@/components/SofiaRei/Busca/SearchRascunho.vue"

  /* services */
  import CartorioService from "@/services/CartorioService"
  import RegistrosService from "@/services/Registros"
  import ObitoService from "@/services/Registros/Obito"
  import BuscaService from "@/services/BuscaService"
  import EProtocoloService from '@/services/EProtocoloService'

  /* constantes */
  import objSwal from '@/constants/swalValues'
  import { getDocuments } from "@/constants/documentosPessoais"
  import { locaisObito } from '@/constants/locaisObito'

  /* filters */
  import { filterMaskedNumber } from '@/filters/filters'

  /* outros */
  import { mapGetters } from 'vuex'
  import Swal from "sweetalert2"
  import moment from "moment"

  export default {
    name: 'CadastroObito',
    components: {SearchRascunho, HeaderForSection, StepsForWizard, PassoFalecido, PassoDadosFalecimento, PassoOutrasInfo, PassoRegistro },
    data () {
      return {
        natimorto: false,
        desconhecido: false,
        passoAtivo: 0,
        obito_id: null,
        dados: {
          pessoa: {},
          idade_tipo: null,
          genitores: [],
          medicos: [],
          documentos: [],
          filhoDeixado: [],
          registro: {
            anteriores: [],
            partes: [],
            tipo_registro: '',
            cartorio_id: this.$store.state.auth.cartorio_id
          },
          sexo: '',
          cor_pele: '',
          estado_civil: 'IGNORADO',
          causaObito: { tipo_morte: '' },
          nacionalidade: {
            codigo: 76,
            nome: "Brasil",
            nome_feminino: "brasileira",
            nome_masculino: "brasileiro",
          },
          sem_declaracao_obito: false,
          semanas_gestacao: false,
          qtd_gemeos: null

        },
        passos: [
          { texto: 'Falecido' },
          { texto: 'Dados do Falecimento' },
          { texto: 'Outras Informações' },
          { texto: 'Registro' }
        ],
        dadosCartorio: {},
        parte: {},
        dataInicio: '',
        showModalRascunho: false,
        rascunhoFound: null
      }
    },
    provide: function () {
      return {
        $validator: this.$validator
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId',
        arquivoEstruturado: 'eProtocolo/getArquivoEstruturado'
      }),
      nextEnabled () {
        let disableIt = false

        if (this.passoAtivo === 0) {
          if (this.dados.natimorto && !this.dados.nome) {
            this.dados.nome = 'SEM DESIGNAÇÃO DO NOME'
          }
          disableIt = !this.dados.nome
        }

        return disableIt
      },
    },
    async beforeCreate () {
      if (this.$route.params.id) {
        const { document, created_at } =  await RegistrosService.getRascunhoById(this.$route.params.id)        
        const pessoa = document && document.registro && document.registro.pessoa
        const dados = pessoa && pessoa.nome ? pessoa : document

        this.dados = {
          ...dados,
          rascunho_id: this.$route.params.id
        }
        this.dataInicio = created_at

        if (!this.dados) {
          this.$router.push('/pagina-nao-encontrada')
        }

        if (this.obito && this.obito.obito_id) {
          return this.$router.push({ name: 'editar_obito', params: { id: this.obito.obito_id } })
        }
      }
    },
    mounted () {
      this.getCartorio()
      this.usarArquivoEstruturado()
    },
    methods: {
      nextStep () {
        if (!this.validateCpfDuplicate()) return

        if (this.$route.params.id === 'novo') {
          return displayMessage('error', 'Acesso negado!', 'Você não tem permissão para acessar essa função.')
        }

        this.$validator.validate().then(resp => {
          if (resp && !this.nextEnabled) {
            const {pessoa, tipo} = this.parte

            if (pessoa && pessoa.nome && tipo === 'DECLARANTE') {
              this.dados.registro.partes.push(this.parte)
              this.parte = {}
            }

            let limit = this.passos.length
            if ((limit === this.passoAtivo) || (this.passoAtivo === this.passos.length)) return
            window.scrollTo({top: 0, behavior: 'smooth'})
            return this.processStep()
          } else {
            let invalids = document.querySelectorAll('.is-invalid')
            this.invalids(invalids)
          }
        })
      },

      previousStep () {
        if (this.passoAtivo === 0) return
        this.passoAtivo = this.passoAtivo - 1
        window.scrollTo({top: 0, behavior: 'smooth'})
      },

      async processStep () {
        switch (this.passoAtivo) {
        case 0: return this.updateRascunho()
        case 1: return this.updateRascunho()
        case 2: return this.updateRascunho()
        case 3: return this.finalStep()
        }
      },

      validateCpfDuplicate () {
        if (this.dados.genitores) {
          const genitorComCpfFalecido = this.dados.genitores
            .filter((genitor) => {
              if (genitor.pessoa.cpf && this.dados.cpf) {
                return genitor.pessoa.cpf === filterMaskedNumber(this.dados.cpf)
              }
            })

          if (genitorComCpfFalecido.length) {
            objSwal.error.title = 'Erro ao cadastrar genitor'
            objSwal.error.text = `O CPF ${this.dados.cpf} já cadastrado para o falecido ${this.dados.nome}`
            Swal.fire(objSwal.error)

            return false
          }

          return true
        }
      },
      async searchRascunho (data) {
        this.dados.registro.tipo_registro = this.dados.natimorto ? 'NT' : 'O'
        this.rascunhoFound = await BuscaService.searchRascunhoBeforeSave(this.dados.registro, data)
        if (this.rascunhoFound) {
          this.showModalRascunho = true
        } else {
          this.newRascunho()
        }
      },
      async newRascunho () {
        if (!this.$route.params.id) {
          try {
            loader({ text: 'Gravando Rascunho do Registro', active: true })

            this.dados.registro.tipo_registro = this.dados.natimorto ? 'NT' : 'O'

            const rascunho = await RegistrosService.storeRascunho({ document: this.dados })
            this.dados = rascunho.document
            this.dados.rascunho_id = rascunho.rascunho_id

            RegistrosService.updateRascunho(this.dados.rascunho_id, { document: this.dados })

            loader({ active: false })

            this.$toast.success('Rascunho salvo com sucesso!', {
              position: 'top-right',
              duration: 5000
            })

            this.$router.push({ name: 'editar_obito_rascunho', params: { id: rascunho.rascunho_id } })

          } catch (error) {
            const message = getErrors(error)

            displayMessage('error', 'Erro!', message.message)

            setTimeout(() => {
              const btnConfirm = document.querySelector('.swal2-confirm')

              if (btnConfirm) btnConfirm.focus()
            }, 300)
          }
        }
      },

      async updateRascunho () {
        try {
          loader({ text: 'Atualizando Rascunho', active: true })

          await RegistrosService.updateRascunho(this.dados.rascunho_id, { document: this.dados })
          this.passoAtivo++

          loader({ active: false })
        } catch (err) {
          objSwal.error.title = 'Erro ao processar etapa'
          objSwal.error.text = err.message
          return Swal.fire(objSwal.error)
        }
      },

      updatePassoRegistro (registro) {
        this.dados.registro = { ...this.dados.registro, ...registro}
        RegistrosService.updateRascunho(this.dados.rascunho_id, { document: this.dados })
      },

      async finalStep () {
        try {
          loader({ text: 'Cadastrando registro de Óbito', active: true })
          this.dados.cartorio_id = this.$store.state.auth.cartorio_id

          if (this.dados.numero_declaracao_obito) {
            this.dados.numero_declaracao_obito = this.dados.numero_declaracao_obito.replace('-', '').replace('-', '')
          } else {
            this.dados.numero_declaracao_obito = null
          }

          if (!this.dados.sem_declaracao_obito) this.dados.sem_declaracao_obito = false

          this.dados.registro.oficial = this.dadosCartorio.nome_oficial

          this.dados.pessoa = {
            cpf: this.dados.cpf,
            cpf_sem_inscricao: this.dados.cpf_sem_inscricao,
            nome: this.dados.nome,
            data_nascimento: this.dados.data_nascimento ? moment(String(this.dados.data_nascimento), 'DD/MM/YYYY').format('YYYY-MM-DD') : null,
            sexo: this.dados.sexo,
            cor_pele: this.dados.cor_pele,
            nacionalidade: this.dados.nacionalidade,
            nacionalidade_codigo: this.dados.nacionalidade_codigo,
            estado_civil: this.dados.estado_civil,
            ocupacao_codigo: this.dados.ocupacao_codigo,
            ocupacao_declarada: this.dados.ocupacao_declarada,
            naturalidade: this.dados.naturalidade,
            naturalidade_declarada: this.dados.naturalidade_declarada,
            uf: this.dados.uf,
            idade: this.dados.idade,
            pessoa_desconhecida: this.dados.pessoa_desconhecida,
            endereco: this.dados.endereco,
            documentos: this.dados.documentos,
            genitores: this.dados.genitores,
            ultimo_convivente: this.dados.ultimo_convivente
          }

          // Remove a propriedade 'ultimo_convivente' do objeto 'dados'
          // Já que ultimo_convivente será passado de dentro da propriedade registro.pessoa
          delete this.dados.ultimo_convivente

          const obito = await ObitoService.registrarObito(this.dados)
          
          if (this.$route.query.origem === 'arquivo-estruturado') {
            // Salvar o registro_id na tabela e_protocolo através do hash
            await EProtocoloService.vincularRegistroId(this.arquivoEstruturado.hash, obito.registro_id)
          }

          objSwal.success.title = "Registro realizado com Sucesso!"
          objSwal.success.text = ''
          objSwal.success.html = ''

          setTimeout(() => {
            const btnConfirm = document.querySelector('.swal2-confirm')

            if (btnConfirm) btnConfirm.focus()
          }, 300)

          loader({ text: "", active: false })

          return Swal.fire(objSwal.success).then(() => {
            this.$router.push({ name: 'resumo_obito', params: { id: obito.obito_id, propNovo: true } })
              .catch(() => {
                this.$router.push('/')
              })
          })
        } catch (error) {
          try {
            if (!error.response) {
              console.error(error)
              return this.displayError('TEXT', error)
            } else {
              if (Array.isArray(error.response.data)) {
                const messages = []

                error.response.data.forEach(resp => {
                  switch (resp.message) {
                  case 'unique validation failed on obito.numero_declaracao_obito':
                    messages.push(`A D.O ${this.dados.numero_declaracao_obito} já está vinculada à outro registro`)
                    break
                  case 'required validation failed on registro.oficial':
                    messages.push(`É necessário cadastrar o oficial no menu de serventia.`)
                    break
                  case 'sofia validation failed on obito.numero_declaracao_obito':
                    messages.push(`D.O Número ${this.dados.numero_declaracao_obito} não é válida.`)
                    break
                  }
                })

                const textSwal = `<ul>${messages.map(res => {
                  return `<li>${res}</li>`
                })}</ul>`

                const html = textSwal.replace(/\,/g,'')

                return this.displayError('HTML', html)
              }
              if (error.response.data.message && !error.response.data.message.message) {
                return this.displayError('TEXT', error.response.data.message).then(() => {
                  const msgs = [
                    'Configuração do Livro inválida!',
                    'Sequência do Livro inválida!',
                    'Sequências dos livros',
                    'Configurações dos livros'
                  ]

                  if (msgs.includes(error.response.data.message)) {
                    this.$router.push({ name: 'cadastro_serventia', params: { propConfigLivro: true }})
                  }
                })
              } else if (error.response.data && error.response.data.error && error.response.data.error.message) {
                if (error.response.data.error.message.match(/.*pessoa_cpf_unique.*/)) {
                  const duplicate = error.response.data.error.message.match(/Duplicate entry (.*)/)[1]
                  const cpf = duplicate.split(' ')[0]
                  return this.displayError('TEXT', `Já existe uma pessoa cadastrada com o cpf ${cpf}`)
                }
              }

              if (error.response.data && error.response.data.error) {
                return this.displayError('TEXT', error.response.data.error.message)
              }
            }
          } catch (error) {
            const text  = 'Houve algum erro ao cadastrar um novo registro de óbito, favor contactar o suporte.'

            return this.displayError('TEXT', text)
          }
          finally {
            loader({ text: '', active: false })
            delete objSwal.error.html
          }
        }
      },

      async changed (data) {
        this.dados = { ...data }

        const { rascunho_id, nome, cpf, cpf_sem_inscricao, tipo_registro_obito, pessoa_desconhecida } = this.dados

        if (!rascunho_id && nome && ((cpf || cpf_sem_inscricao) || (tipo_registro_obito == "NT" || pessoa_desconhecida))) {
          this.searchRascunho(this.dados)
        }

        if (rascunho_id) {
          await RegistrosService.updateRascunho(this.dados.rascunho_id, { document: this.dados })
        }
      },

      invalids (list) {
        if (list.length) {
          list[0].scrollIntoView({ behavior: 'smooth', block: 'center', inline: "nearest" })
        }
      },
      async getCartorio () {
        this.dadosCartorio = this.$store.getters['auth/getCartorioObj']
      },
      documentoRemoved (documento) {
        this.dados.genitores.splice(documento.localId, 1)
      },
      displayError (type, message) {
        objSwal.error.title = 'Erro ao cadastrar'

        if (type === 'HTML') {
          objSwal.error.text = ''
          objSwal.error.html = message
        } else {
          objSwal.error.text = message
          objSwal.error.html = ''
        }

        loader({ text: '', active: false })

        return Swal.fire(objSwal.error)
      },
      verifyParte (parte) {
        this.parte = parte
      },
      montarDadosArquivoEstruturado () {
        const falecido = this.arquivoEstruturado.registro.falecido
        const dadosFalecimento = this.arquivoEstruturado.registro.dados_falecimento
        const registroEstruturado = this.arquivoEstruturado.registro
        
        this.dados = {
          ...this.dados,

          // ==============================
          // FALECIDO
          // ==============================

          nome: falecido.nome,
          cpf: falecido.CPF,
          data_nascimento: falecido.data_nascimento
            ? falecido.data_nascimento.replace(/-/g, '/')
            : null,
          idade: falecido.idade,
          idade_tipo: falecido.tipo_idade,
          sexo: {
            Masculino: 'M',
            masculino: 'M',
            Feminino: 'F',
            feminino: 'F'
          }[falecido.sexo] || 'I',
          cor_pele: falecido.cor.toUpperCase(),
          estado_civil: falecido.estado_civil
            ? falecido.estado_civil.toUpperCase()
            : 'IGNORADO',
          ultimo_convivente: falecido.conjuge
            ? falecido.conjuge.nome
            : '',
          ocupacao_declarada: falecido.profissao,
          naturalidade: falecido.naturalidade,
          uf: falecido.naturalidade_uf,
          endereco: falecido.endereco_residencia_falecido
            ? {
              cep: falecido.endereco_residencia_falecido.cep,
              logradouro: falecido.endereco_residencia_falecido.logradouro,
              numero: falecido.endereco_residencia_falecido.numero,
              complemento: falecido.endereco_residencia_falecido.complemento,
              bairro: falecido.endereco_residencia_falecido.bairro,
              cidade: falecido.endereco_residencia_falecido.cidade,
              uf: falecido.endereco_residencia_falecido.uf
            }
            : {},
          genitores: (falecido.filiacao || []).map(genitor => ({
            pessoa: {
              nome: genitor.nome,
              sexo: {
                Masculino: 'M',
                masculino: 'M',
                Feminino: 'F',
                feminino: 'F'
              }[genitor.sexo] || 'I',
              naturalidade: genitor.naturalidade,
              uf: genitor.naturalidade_uf,
              ocupacao_declarada: genitor.profissao,
              endereco: genitor.endereco_residencia_filiacao
                ? {
                  cep: genitor.endereco_residencia_filiacao.cep,
                  logradouro: genitor.endereco_residencia_filiacao.logradouro,
                  numero: genitor.endereco_residencia_filiacao.numero,
                  complemento: genitor.endereco_residencia_filiacao.complemento,
                  bairro: genitor.endereco_residencia_filiacao.bairro,
                  cidade: genitor.endereco_residencia_filiacao.cidade,
                  uf: genitor.endereco_residencia_filiacao.uf
                }
                : {}
            }
          })),

          // ==============================
          // DADOS DO FALECIMENTO
          // ==============================

          numero_declaracao_obito: dadosFalecimento
            ? dadosFalecimento.do
            : null,

          registro: {
            ...this.dados.registro,

            // ==============================
            // PARTES — DECLARANTE
            // ==============================

            partes: registroEstruturado.declarante
              ? [{
                tipo: 'DECLARANTE',
                pessoa: {
                  nome: registroEstruturado.declarante.nome,
                  cpf: registroEstruturado.declarante.cpf,
                  ocupacao_declarada: registroEstruturado.declarante.profissao,
                  estado_civil: registroEstruturado.declarante.estado_civil,
                  nacionalidade_codigo: 76,
                  nacionalidade: {
                    nacionalidade_codigo: 76,
                    nome: 'Brasil',
                    nome_masculino: 'brasileiro',
                    nome_feminino: 'brasileira'
                  },
                  documentos: registroEstruturado.declarante.documento_identificacao
                    ? [{
                      tipo_documento: this.tipoDocumento(
                        registroEstruturado.declarante.documento_identificacao_tipo
                      ),
                      numero: registroEstruturado.declarante.documento_identificacao,
                      orgao_emissor: registroEstruturado.declarante.documento_identificacao_orgao
                    }]
                    : [],

                  endereco: registroEstruturado.declarante.endereco_residencia_declarante
                    ? {
                      cep: registroEstruturado.declarante.endereco_residencia_declarante.cep,
                      logradouro: registroEstruturado.declarante.endereco_residencia_declarante.logradouro,
                      numero: registroEstruturado.declarante.endereco_residencia_declarante.numero,
                      complemento: registroEstruturado.declarante.endereco_residencia_declarante.complemento,
                      bairro: registroEstruturado.declarante.endereco_residencia_declarante.bairro,
                      cidade: registroEstruturado.declarante.endereco_residencia_declarante.cidade,
                      uf: registroEstruturado.declarante.endereco_residencia_declarante.uf
                    }
                    : {}
                }
              }]
              : [],
            
            data_ocorrido: dadosFalecimento.data_falecimento
              ? moment(dadosFalecimento.data_falecimento, 'DD-MM-YYYY').format('YYYY-MM-DD')
              : null,

            hora_ocorrido: dadosFalecimento
              ? dadosFalecimento.hora_falecimento
              : null,

            local: dadosFalecimento && dadosFalecimento.local_falecimento
              ? {
                tipo: (() => {
                  const tipoLocal = dadosFalecimento.local_falecimento.tipo_local_falecimento
                  const local = locaisObito.find(
                    local => local.name.toUpperCase() === tipoLocal.toUpperCase()
                  )

                  return local ? local.val : tipoLocal
                })(),

                descricao: dadosFalecimento.local_falecimento.Nome_local_falecimento,

                endereco: dadosFalecimento.local_falecimento.endereco_local_falecimento
                  ? {
                    cep: dadosFalecimento.local_falecimento.endereco_local_falecimento.cep,
                    logradouro: dadosFalecimento.local_falecimento.endereco_local_falecimento.logradouro,
                    numero: dadosFalecimento.local_falecimento.endereco_local_falecimento.numero,
                    complemento: dadosFalecimento.local_falecimento.endereco_local_falecimento.complemento,
                    bairro: dadosFalecimento.local_falecimento.endereco_local_falecimento.bairro,
                    cidade: dadosFalecimento.local_falecimento.endereco_local_falecimento.cidade,
                    uf: dadosFalecimento.local_falecimento.endereco_local_falecimento.uf
                  }
                  : {}
              }
              : this.dados.registro.local
          },

          // ==============================
          // CAUSA DA MORTE
          // ==============================

          causaObito: dadosFalecimento && dadosFalecimento.causa_morte
            ? {
              ...this.dados.causaObito,

              causa_morte_parte_1_a: dadosFalecimento.causa_morte.find(causa => causa.causa_morte_A)
                ? dadosFalecimento.causa_morte.find(causa => causa.causa_morte_A).causa_morte_A
                : null,

              causa_morte_parte_1_b: dadosFalecimento.causa_morte.find(causa => causa.causa_morte_B)
                ? dadosFalecimento.causa_morte.find(causa => causa.causa_morte_B).causa_morte_B
                : null,

              causa_morte_parte_1_c: dadosFalecimento.causa_morte.find(causa => causa.causa_morte_C)
                ? dadosFalecimento.causa_morte.find(causa => causa.causa_morte_C).causa_morte_C
                : null,

              causa_morte_parte_1_d: dadosFalecimento.causa_morte.find(causa => causa.causa_morte_d)
                ? dadosFalecimento.causa_morte.find(causa => causa.causa_morte_d).causa_morte_d
                : null
            }
            : this.dados.causaObito,

          // ==============================
          // MÉDICOS
          // ==============================

          medicos: (dadosFalecimento && dadosFalecimento.medicos
            ? dadosFalecimento.medicos
            : []
          ).map(medico => ({
            nome: medico.nome,
            crm: medico.crm,
            uf: medico.crm_uf
          })),

          // ==============================
          // SEPULTAMENTO
          // ==============================

          sepultamento: dadosFalecimento && dadosFalecimento.local_sepultamento
            ? {
              nome: dadosFalecimento.local_sepultamento.nome_local_sepultamento,
              endereco: {
                uf: dadosFalecimento.local_sepultamento.uf_local_sepultamento,
                cidade: dadosFalecimento.local_sepultamento.cidade_local_sepultamento
              }}
            : null,

          // ==============================
          // OUTRAS INFORMAÇÕES
          // ==============================

          documentos: (this.arquivoEstruturado.registro.documentos_falecido || []).map(documento => ({
            tipo_documento: this.tipoDocumento(documento.tipo),
            numero: documento.documento,
            uf_emissor: documento.uf_emissao,
            data_emissao: documento.data_emissao
              ? moment(documento.data_emissao, 'DD-MM-YYYY').format('YYYY-MM-DD')
              : null
          })),

          deixa_bens: registroEstruturado.deixou_bens,
          deixa_testamento: registroEstruturado.testamento,
          eleitor_ativo: registroEstruturado.era_eleitor,
          deixa_filhos: registroEstruturado.deixou_filhos,
          filhoDeixado: (this.arquivoEstruturado.registro.filhos || []).map(filho => ({
            nome: filho.nome,
            idade: filho.idade,
            idade_tipo: {
              anos: 'A',
              meses: 'M',
              dias: 'D'
            }[filho.tipo_idade] || 'I',
            filho_falecido: !!filho.filho_falecido
          })),
        }
      },
      async usarArquivoEstruturado () {
        const { origem } = this.$route.query

        if (origem !== 'arquivos-estruturados' || !this.arquivoEstruturado?.registro) {
          return
        }
 
        this.montarDadosArquivoEstruturado ()

        try {
          loader({ text: 'Gravando Rascunho do Registro', active: true })

          this.dados.registro.tipo_registro = this.dados.natimorto ? 'NT' : 'O'

          const rascunho = await RegistrosService.storeRascunho({ document: this.dados })
          this.dados = rascunho.document
          this.dados.rascunho_id = rascunho.rascunho_id

          await RegistrosService.updateRascunho(this.dados.rascunho_id, { document: this.dados })
          
          loader({ active: false })

          this.$toast.success('Rascunho salvo com sucesso!', {
            position: 'top-right',
            duration: 5000
          })

          this.$router.push({ name: 'editar_obito_rascunho', params: { id: rascunho.rascunho_id }, query: { origem: 'arquivo-estruturado' }})

        } catch (error) {
          const message = getErrors(error)

          displayMessage('error', 'Erro!', message.message)

          setTimeout(() => {
            const btnConfirm = document.querySelector('.swal2-confirm')

            if (btnConfirm) btnConfirm.focus()
          }, 300)
        }
      },
      tipoDocumento (tipo) {
        if (!tipo) return 'NAO_IDENTIFICADO'

        const tipoNormalizado = tipo.toUpperCase().trim()

        const documentos = getDocuments()

        const documentoExistente = documentos.find(
          doc => doc.key === tipoNormalizado
        )

        if (documentoExistente) {
          return documentoExistente.key
        }

        return 'NAO_IDENTIFICADO'
      }
    }
  }
</script>

<style lang="scss">
  @import '../../scss/_utilities/_exports';

  .btn-danger {
    background-color: #8B0000;
    border-color: #8B0000
  }

  .btn-primary {
    background-color: #086AAE;
    border-color: #086AAE
  }
</style>
